import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[nationalityDetailDirective]',
})
export class NationalityDetailDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}